<template>
  <div
      class="post-preview-card__link-wrapper"
  >
    <div>
      <div
          class="u-cursor-pointer"
          @click="toggleLink"
      >
        <div class="link-wrapper__link-box align-center">
          <div>
            <div class="d-flex align-center">
              <img
                  v-if="metadata && metadata.image"
                  class="link-wrapper__link-box__image mr-1"
                  :src="metadata.image"
                  alt="link preview"
              />
              <h1
                  class="link-wrapper__link-box__title"
              >
                {{
                  threadActionTitle || (metadata && metadata.title)
                }}
              </h1>
            </div>
            <div v-if="metadata && metadata.description" class="link-wrapper__link mt-1">
              {{ metadata && metadata.description}}
            </div>
          </div>
          <Icon type="chevron_right" :size="20" color="#9b9b9b"/>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'LinkInfo',
  props:{
    metadata:{
      type: Object,
      default: () => ({})
    },
    threadActionTitle:{
      type: String,
      default: ''
    },
    streamUrl:{
      type: String,
      default: ''
    }
  },
  methods:{
    toggleLink(){
      this.$emit('toggleLink')
    }
  }
}

</script>

<style lang="scss">
.link-wrapper {
  padding: 12px 12px 0 12px;

  &__link {
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 19.36px;
    color: var(--link);
    max-width: fit-content;
  }

  &__link-box {
    height: auto;
    padding: 12px;
    background-color: #f3f3f6;
    border-radius: 8px;
    display: flex;
    justify-content: space-between;

    &__image {
      width: 16px;
      height: 16px;
      border-radius: 2px;
    }

    &__title {
      font-family: 'Inter', sans-serif;
      font-weight: 700;
      font-size: 14px;
      line-height: 16.94px;
      color: var(--username-category-title);
    }
  }
}

</style>